import { defineComponent, useCssVars, ref, onBeforeMount, onMounted, getCurrentInstance, watch, nextTick, onBeforeUnmount, createBlock, createCommentVNode, openBlock, Teleport, createVNode, Transition, withCtx, withDirectives, createElementVNode, normalizeStyle, normalizeClass, vShow, renderSlot, createElementBlock, toDisplayString, withModifiers, createTextVNode } from "vue";
import { _ as _sfc_main$1 } from "./chunks/p-alert.js";
import PCloseBtn from "./p-close-btn.js";
import { usePModal } from "./usePModal.js";
import { _ as _export_sfc } from "./chunks/_plugin-vue_export-helper.js";
const _hoisted_1 = ["data-pm-backdrop-id"];
const _hoisted_2 = ["data-pm-wrapper-id", "aria-label", "aria-describedby", "aria-labelledby"];
const _hoisted_3 = ["data-pm-id"];
const _hoisted_4 = { class: "flex pb-4 pl-8 pr-4 pt-4" };
const _hoisted_5 = ["id"];
const _hoisted_6 = { class: "ml-auto" };
const _hoisted_7 = {
  key: 0,
  class: "mb-4 px-8"
};
const _hoisted_8 = ["id"];
const _hoisted_9 = {
  key: 0,
  class: "px-8 pt-6"
};
const FOCUSABLE_ELEMENTS = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex]:not([tabindex="-1"])';
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PModal"
  },
  __name: "p-modal",
  props: {
    name: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    baseZindex: {
      type: Number,
      default: 1051
    },
    bgClass: {
      type: [String, Object, Array],
      default: "fixed bottom-0 left-0 right-0 top-0 bg-black/20"
    },
    wrapperClass: {
      type: [String, Object, Array],
      default: "fixed bottom-0 left-0 right-0 top-0 flex flex-col items-center justify-center overflow-y-auto overflow-x-hidden outline-none"
    },
    modalClass: {
      type: [String, Object, Array],
      default: "pm relative flex flex-col rounded-2xl pb-6 cursor-default bg-surface shadow-xl"
    },
    modalStyle: {
      type: [String, Object, Array],
      default: ""
    },
    inClass: {
      type: String,
      default: "slideInTop"
    },
    outClass: {
      type: String,
      default: "slideOutTop"
    },
    bgInClass: {
      type: String,
      default: "fadeIn"
    },
    bgOutClass: {
      type: String,
      default: "fadeOut"
    },
    appendTo: {
      type: String,
      default: "body"
    },
    live: {
      type: Boolean,
      default: false
    },
    enableClose: {
      type: Boolean,
      default: true
    },
    modelValue: {
      type: Boolean,
      default: false
    },
    closeLabel: {
      type: String,
      default: "Close"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMsg: {
      type: String,
      default: ""
    },
    maxWidth: {
      type: String,
      default: "500px"
    }
  },
  emits: [
    "before-open",
    "opening",
    "opened",
    "before-close",
    "closing",
    "closed",
    "update:modelValue"
  ],
  setup(__props, { emit: __emit }) {
    useCssVars((_ctx) => ({
      "9a05239e": __props.maxWidth
    }));
    let animatingZIndex = 0;
    const emit = __emit;
    const props = __props;
    const modal = usePModal();
    const zIndex = ref(0);
    const id = ref("");
    const show = ref(false);
    const mount = ref(false);
    const elToFocus = ref(null);
    const pmWrapper = ref(null);
    onBeforeMount(() => {
      if (props.live) {
        mount.value = true;
      }
    });
    onMounted(() => {
      var _a;
      id.value = "pm-" + ((_a = getCurrentInstance()) == null ? void 0 : _a.uid);
      const valueToWatch = !props.name ? () => props.modelValue : () => modal.state.modals[props.name];
      watch(
        valueToWatch,
        (newVal) => {
          if (newVal) {
            mount.value = true;
            nextTick(() => {
              show.value = true;
            });
          } else {
            show.value = false;
          }
        },
        {
          immediate: true
        }
      );
    });
    onBeforeUnmount(() => {
      elToFocus.value = null;
      props.name && modal.hide(props.name);
    });
    const close = () => {
      if (props.enableClose === true) {
        emit("update:modelValue", false);
        props.name && modal.hide(props.name);
      }
    };
    const clickOutside = (e) => {
      if (e.target === pmWrapper.value) {
        close();
      }
    };
    const keydown = (e) => {
      var _a;
      if (e.which === 27 || e.keyCode === 27) {
        close();
      }
      if (e.which === 9 || e.keyCode === 9) {
        const all = [].slice.call((_a = pmWrapper.value) == null ? void 0 : _a.querySelectorAll(FOCUSABLE_ELEMENTS)).filter(function(el) {
          return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
        });
        if (e.shiftKey) {
          if (e.target === all[0] || e.target === pmWrapper.value) {
            e.preventDefault();
            all[all.length - 1].focus();
          }
        } else {
          if (e.target === all[all.length - 1]) {
            e.preventDefault();
            all[0].focus();
          }
        }
      }
    };
    const getAllVisibleWrappers = () => {
      return [].slice.call(document.querySelectorAll("[data-pm-wrapper-id]")).filter((w) => w.style.display !== "none");
    };
    const getTopZindex = () => {
      return getAllVisibleWrappers().reduce((acc, curr) => {
        return parseInt(curr.style.zIndex) > acc ? parseInt(curr.style.zIndex) : acc;
      }, 0);
    };
    const handleFocus = (wrapper) => {
      if (!wrapper) {
        return;
      }
      const autofocus = wrapper.querySelector("[autofocus]");
      if (autofocus) {
        autofocus.focus();
      } else {
        const focusable = wrapper.querySelectorAll(FOCUSABLE_ELEMENTS);
        focusable.length ? focusable[0].focus() : wrapper.focus();
      }
    };
    const beforeOpen = () => {
      elToFocus.value = document.activeElement;
      const lastZindex = getTopZindex();
      if (animatingZIndex) {
        zIndex.value = animatingZIndex + 2;
      } else {
        zIndex.value = lastZindex === 0 ? props.baseZindex : lastZindex + 2;
      }
      animatingZIndex = zIndex.value;
      emit("before-open");
    };
    const opening = () => {
      emit("opening");
    };
    const afterOpen = () => {
      handleFocus(pmWrapper.value);
      emit("opened");
    };
    const beforeClose = () => {
      emit("before-close");
    };
    const closing = () => {
      emit("closing");
    };
    const afterClose = () => {
      zIndex.value = 0;
      if (!props.live) {
        mount.value = false;
      }
      nextTick(() => {
        window.requestAnimationFrame(() => {
          var _a, _b;
          const lastZindex = getTopZindex();
          if (lastZindex > 0) {
            const all = getAllVisibleWrappers();
            for (let i = 0; i < all.length; i++) {
              const wrapper = all[i];
              if (parseInt(wrapper.style.zIndex) === lastZindex) {
                if (wrapper.contains(elToFocus.value)) {
                  (_a = elToFocus.value) == null ? void 0 : _a.focus();
                } else {
                  handleFocus(wrapper);
                }
                break;
              }
            }
          } else {
            if (document.body.contains(elToFocus.value)) {
              (_b = elToFocus.value) == null ? void 0 : _b.focus();
            }
          }
          animatingZIndex = 0;
          emit("closed");
        });
      });
    };
    return (_ctx, _cache) => {
      return mount.value ? (openBlock(), createBlock(Teleport, {
        key: 0,
        to: __props.appendTo
      }, [
        createVNode(Transition, {
          name: "pm-backdrop-transition",
          "enter-active-class": __props.bgInClass,
          "leave-active-class": __props.bgOutClass
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              "data-pm-backdrop-id": id.value,
              class: normalizeClass(__props.bgClass),
              style: normalizeStyle({ "z-index": zIndex.value - 1 })
            }, null, 14, _hoisted_1), [
              [vShow, show.value]
            ])
          ]),
          _: 1
        }, 8, ["enter-active-class", "leave-active-class"]),
        createVNode(Transition, {
          name: "pm-transition",
          "enter-active-class": __props.inClass,
          "leave-active-class": __props.outClass,
          onBeforeEnter: beforeOpen,
          onEnter: opening,
          onAfterEnter: afterOpen,
          onBeforeLeave: beforeClose,
          onLeave: closing,
          onAfterLeave: afterClose
        }, {
          default: withCtx(() => [
            withDirectives(createElementVNode("div", {
              ref_key: "pmWrapper",
              ref: pmWrapper,
              "data-pm-wrapper-id": id.value,
              tabindex: "-1",
              class: normalizeClass(__props.wrapperClass),
              style: normalizeStyle({ "z-index": zIndex.value, cursor: __props.enableClose ? "pointer" : "default" }),
              role: "dialog",
              "aria-label": __props.title,
              "aria-modal": "true",
              "aria-describedby": `${id.value}-content`,
              "aria-labelledby": `${id.value}-title`,
              onClick: _cache[0] || (_cache[0] = ($event) => clickOutside($event)),
              onKeydown: _cache[1] || (_cache[1] = ($event) => keydown($event))
            }, [
              createElementVNode("div", {
                ref: "pm",
                "data-pm-id": id.value,
                class: normalizeClass(__props.modalClass),
                style: normalizeStyle(__props.modalStyle)
              }, [
                renderSlot(_ctx.$slots, "title-wrapper", {}, () => [
                  createElementVNode("div", _hoisted_4, [
                    __props.title ? (openBlock(), createElementBlock("h3", {
                      key: 0,
                      id: `${id.value}-title`,
                      class: "mr-auto pt-4 text-xl font-semibold"
                    }, toDisplayString(__props.title), 9, _hoisted_5)) : createCommentVNode("", true),
                    createElementVNode("div", _hoisted_6, [
                      createVNode(PCloseBtn, {
                        disabled: __props.disabled,
                        class: normalizeClass({ invisible: !__props.enableClose }),
                        "aria-label": __props.closeLabel,
                        onClick: withModifiers(close, ["prevent"])
                      }, null, 8, ["disabled", "class", "aria-label"])
                    ])
                  ])
                ], true),
                __props.errorMsg ? (openBlock(), createElementBlock("div", _hoisted_7, [
                  createVNode(_sfc_main$1, { type: "error" }, {
                    default: withCtx(() => [
                      createTextVNode(toDisplayString(__props.errorMsg), 1)
                    ]),
                    _: 1
                  })
                ])) : createCommentVNode("", true),
                renderSlot(_ctx.$slots, "content-wrapper", {}, () => [
                  createElementVNode("div", {
                    id: `${id.value}-content`,
                    class: normalizeClass([
                      "relative grow overflow-y-auto overflow-x-hidden px-8",
                      { "pointer-events-none opacity-50": __props.disabled }
                    ])
                  }, [
                    renderSlot(_ctx.$slots, "default", {}, void 0, true)
                  ], 10, _hoisted_8)
                ], true),
                renderSlot(_ctx.$slots, "footer-wrapper", {}, () => [
                  _ctx.$slots.footer ? (openBlock(), createElementBlock("div", _hoisted_9, [
                    renderSlot(_ctx.$slots, "footer", {}, void 0, true)
                  ])) : createCommentVNode("", true)
                ], true)
              ], 14, _hoisted_3)
            ], 46, _hoisted_2), [
              [vShow, show.value]
            ])
          ]),
          _: 3
        }, 8, ["enter-active-class", "leave-active-class"])
      ], 8, ["to"])) : createCommentVNode("", true);
    };
  }
});
const pModal = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-c3379c94"]]);
export {
  pModal as default
};
